document.addEventListener("DOMContentLoaded", function() {
  const timeCounts = document.querySelectorAll("[data-countdown-time]");
  timeCounts.forEach(timeCount => {
    const endTime = new Date(timeCount.getAttribute("data-countdown-time")).getTime();
    
    function updateCountdown() {
      const now = new Date().getTime();
      const distance = endTime - now;

      if (distance <= 0) {
        timeCount.textContent = "00 day : 00 hr : 00 min";
        clearInterval(interval);
        return;
      }

      const days = String(Math.floor(distance / (1000 * 60 * 60 * 24))).padStart(2, '0');
      const hours = String(Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))).padStart(2, '0');
      const minutes = String(Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))).padStart(2, '0');
      const daysText = days < "02" ? `${days} day : ` : `${days} days : `;
      const hoursText = hours < "02" ? `${hours} hr : ` : `${hours} hrs : `;
      const minutesText = minutes < "02" ? `${minutes} min` : `${minutes} mins`;

      timeCount.textContent = `${daysText} ${hoursText} ${minutesText}`;
    }

    const interval = setInterval(updateCountdown, 1000);
    updateCountdown(); // Initial run
  });

  const toggleMore = document.querySelectorAll('[data-toggle-button]');
  toggleMore?.forEach(button => {
    button.addEventListener('click', () => {
      const id = button.getAttribute('data-toggle-button');
      if (!id) return;
      const itemParent = button.closest(`[data-block-type="${id}"]`);
      itemParent?.classList.toggle('is-expanded');
    });
  });

  // Cop product link to clipboard
  const copyBtn = document.getElementById("copyLinkBtn");
  const input = document.getElementById("shareLink");

  copyBtn?.addEventListener("click", function () {
    input.select();
    input.setSelectionRange(0, 99999); // for mobile
    navigator.clipboard.writeText(input.value).then(() => {
      copyBtn.textContent = "Copied!";
      setTimeout(() => (copyBtn.textContent = "Copy Link"), 2000);
    });
  });

  // Register continue button
  const registerContinueButton = document.querySelectorAll('[data-register-continue]');
  registerContinueButton.forEach(button => {
    button.addEventListener("click", (event) => {
      event.preventDefault();
      const formID = event.target.getAttribute("data-register-continue");
      if (!formID) return;
      document.querySelector(`[form="${formID}"] [type="submit"]`).click();
    });
  });

  // Card badge marquee - only animate if content exceeds container
  function checkBadgeOverflow(container) {
    const marquee = container.querySelector('.card-badge-marquee');
    if (!marquee) return;

    const duplicates = marquee.querySelectorAll('.card-badge[data-duplicate]');
    const duplicateElements = Array.from(duplicates);
    duplicateElements.forEach(dup => dup.remove());
    
    const containerWidth = container.offsetWidth;
    const originalMarqueeWidth = marquee.scrollWidth;
    
    if (originalMarqueeWidth > containerWidth) {
      container.classList.add('has-overflow');
      if (duplicateElements.length === 0) {
        const badges = marquee.querySelectorAll('.card-badge:not([data-duplicate])');
        badges.forEach(badge => {
          const clone = badge.cloneNode(true);
          clone.setAttribute('data-duplicate', 'true');
          marquee.appendChild(clone);
        });
      } else {
        duplicateElements.forEach(dup => marquee.appendChild(dup));
      }
    } else {
      container.classList.remove('has-overflow');
      duplicateElements.forEach(dup => dup.remove());
    }
  }

  function initCardBadgeMarquee() {
    const containers = document.querySelectorAll('.card-badge-container:not([data-marquee-initialized])');
    
    containers.forEach(container => {
      container.setAttribute('data-marquee-initialized', 'true');
      checkBadgeOverflow(container);
    });
  }

  initCardBadgeMarquee();
  
  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      const containers = document.querySelectorAll('.card-badge-container[data-marquee-initialized]');
      containers.forEach(container => checkBadgeOverflow(container));
    }, 150);
  });
  
  const observer = new MutationObserver((mutations) => {
    let hasNewContainers = false;
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (node.nodeType === 1) {
          if (node.classList?.contains('card-badge-container')) {
            hasNewContainers = true;
          } else if (node.querySelector?.('.card-badge-container')) {
            hasNewContainers = true;
          }
        }
      });
    });
    if (hasNewContainers) {
      initCardBadgeMarquee();
    }
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});

// Custom code: tooltip position
class ToolTip extends HTMLElement {
  connectedCallback() {
    const anchor = this.firstElementChild;
    if (!anchor) return;

    this._anchor = anchor;
    this._enter = () => this._show();
    this._leave = () => this._hide();
    this._touch = (e) => {
      e.preventDefault();
      this._tip ? this._hide() : this._show();
    };
  
    this._touchOutside = (e) => {
      if (this._tip && !this.contains(e.target)) this._hide();
    };
    this._onResize = () => { if (this._tip) this._position(); };
    
    anchor.addEventListener('mouseenter', this._enter);
    anchor.addEventListener('mouseleave', this._leave);
    window.addEventListener('resize', this._onResize);
    anchor.addEventListener('touchstart', this._touch);
    document.addEventListener('touchstart', this._touchOutside);
  }


  _show() {
    this._tip = document.createElement('div');
    this._tip.className = 'floating-tip';
    this._tip.textContent = this.getAttribute('content');
    document.body.appendChild(this._tip);
    requestAnimationFrame(() => {
      this._position();
      this._tip.classList.add('visible');
    });
  }

  _position() {
    const tip = this._tip;
    const r = this._anchor.getBoundingClientRect();
    const tw = tip.offsetWidth;
    const th = tip.offsetHeight;
    const vw = window.innerWidth;
    const vh = window.innerHeight;
    const gap = 6;

    const space = {
      top: r.top,
      bottom: vh - r.bottom,
      left: r.left,
      right: vw - r.right,
    };

    const best = Object.keys(space).sort((a, b) => space[b] - space[a])[0];

    let left, top;
    if (best === 'top') {
      left = r.left + r.width / 2 - tw / 2;
      top = r.top - th - gap;
    } else if (best === 'bottom') {
      left = r.left + r.width / 2 - tw / 2;
      top = r.bottom + gap;
    } else if (best === 'left') {
      left = r.left - tw - gap;
      top = r.top + r.height / 2 - th / 2;
    } else {
      left = r.right + gap;
      top = r.top + r.height / 2 - th / 2;
    }

    left = Math.max(8, Math.min(left, vw - tw - 8));
    top = Math.max(8, Math.min(top, vh - th - 8));

    tip.style.left = left + 'px';
    tip.style.top = top + 'px';
  }

  _hide() {
    this._tip?.remove();
    this._tip = null;
  }

  disconnectedCallback() {
    this._anchor?.removeEventListener('mouseenter', this._enter);
    this._anchor?.removeEventListener('mouseleave', this._leave);
    window.removeEventListener('resize', this._onResize);
    this._anchor?.removeEventListener('touchstart', this._touch);
    document.removeEventListener('touchstart', this._touchOutside);
    this._hide();
  }
}

if (!customElements.get('tool-tip')) {
  customElements.define('tool-tip', ToolTip);
}